import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faWhatsapp, faTiktok } from '@fortawesome/free-brands-svg-icons';
import './CustomNavbar.css';

function CustomNavbar() {
    const [expanded, setExpanded] = useState(false); // Estado para controlar el colapso

    const handleSelect = (eventKey) => {
        console.log(`Seleccionado: ${eventKey}`);
        setExpanded(false); // Cerrar el menú después de seleccionar
    };

    const handleToggle = () => {
        setExpanded(!expanded); // Alternar entre abierto y cerrado
    };

    return (
        <Navbar
            bg="white"
            expand="lg"
            fixed="top"
            expanded={expanded}
            style={{
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
            }}
        >
            <Navbar.Brand href="#video-section">
                <img
                    src="/assets/logo.png"
                    alt="Logo Nextia Arquitectura"
                    className="navbar-logo"
                />
            </Navbar.Brand>
            <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                onClick={handleToggle} // Controlar el estado del colapso
            />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto" onSelect={handleSelect}>

                    <Nav.Link title="Conjuntos habitacionales" href="#conjuntos-habitacionales">
                        CONJUNTOS HABITACIONALES
                    </Nav.Link>
                    <Nav.Link title="Vivienda" href="#vivienda">
                        VIVIENDA
                    </Nav.Link>
                    <Nav.Link title="Residencias" href="#residencias">
                        RESIDENCIAS
                    </Nav.Link>
                    <Nav.Link title="Comercial e institucional" href="#comercial-institucional">
                        COMERCIAL E INSTITUCIONAL
                    </Nav.Link>
                    <Nav.Link eventKey="2" href="#nosotros">
                        NOSOTROS
                    </Nav.Link>
                    <Nav.Link eventKey="3" href="#contacto">
                        CONTACTO
                    </Nav.Link>
                </Nav>
                <Nav className="ms-auto social-icons">
                    <Nav.Link href="https://www.facebook.com/render.arqtect" target="_blank">
                        <FontAwesomeIcon icon={faFacebook} size="lg" />
                    </Nav.Link>
                    <Nav.Link
                        href="https://www.instagram.com/taller.arqtect/?fbclid=IwY2xjawG9e5VleHRuA2FlbQIxMAABHatC7I…"
                        target="_blank"
                    >
                        <FontAwesomeIcon icon={faInstagram} size="lg" />
                    </Nav.Link>
                    <Nav.Link href="https://wa.me/4426158054?text=Hola%20Nextia%2C%20me%20gustar%C3%ADa%20recibir%20informaci%C3%B3n%20sobre%20sus%20servicios." target="_blank">
                        <FontAwesomeIcon icon={faWhatsapp} size="lg" />
                    </Nav.Link>
                    <Nav.Link href="https://www.tiktok.com/@tallerarqtect1" target="_blank">
                        <FontAwesomeIcon icon={faTiktok} size="lg" />
                    </Nav.Link>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
}

export default CustomNavbar;
